import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { GoogleMap, LoadScript, Marker, Polyline } from '@react-google-maps/api';
import { Image } from 'primereact/image';

import CSCOHorizontalActionBar from "../../components/CSCOHorizontalActionBar"
import { CSConstantUtil, cfGetConstantValue } from "../../util/CSConstantUtil";
import CSCODetailsSection from "../../components/CSCODetailsSection";
import CSCODetailsHeader from "../../components/CSCODetailsHeader";
import CSCOBackdrop from '../../components/CSCOBackdrop';
import CSRequestUtil from "../../util/CSRequestUtil"
import CSServiceUtil from "../../util/CSServiceUtil"
import { fnGetForm } from "../../util/CSLayoutUtil"
import CSFormUtil from "../../util/CSFormUtil"
import CSUtil from "../../util/CSUtil"
import CSCOGoogle from '../../components/CSCOGoogle';
import { Google_key } from '../../assets/Google_key';
const CSCOGoogleMap = (gProps) => {
    const [mVisible, setVisible] = useState(true);
    const [mLocationHistory, setLocationHistory] = useState([]);
    const [mCurrentLocation, setCurrentLocation] = useState();
    const [mShowBackdrop, setShowBackdrop] = useState(gProps.pShow);
    const [mDetailsFlag, setDetailsFlag] = useState(null);
    const [mFeatureName, setFeatureName] = useState('');



    const lMapContainerStyle = {
        width: '100vw', height: '36vw'
    };

    useEffect(() => {
        if (gProps.hasOwnProperty('pSelectedCriteria')) {
            let lSelectedCriteria = gProps.pSelectedCriteria;
            if (lSelectedCriteria.hasOwnProperty('type_')) {
                if (lSelectedCriteria.type_ === 'LOCATION HISTORY') {
                    fnGetLocationHistory();
                    setFeatureName('LOCATION HISTORY');
                }
                else if (lSelectedCriteria.type_ === 'LIVE LOCATION') {
                    fnGetLiveLocation();
                    setFeatureName('LIVE LOCATION');
                }
            }
        }
    }, [])

    const fnGetLiveLocation = () => {
        if (gProps.hasOwnProperty('pSelectedActionItem') && gProps.pSelectedActionItem.on_click_service_code_) {
            let lServiceCode = gProps.pSelectedActionItem.on_click_service_code_;
            let lServiceObject = (CSServiceUtil.cfGetInstance()).cfGetServiceObject(lServiceCode);
            if (lServiceObject) {
                setShowBackdrop(true);
                let lCriteria = {};

                if (gProps.pSelectedData.employee_id_) {
                    lCriteria.employee_id_ = gProps.pSelectedData.employee_id_;
                }

                if (gProps.pSelectedData.date_) {
                    lCriteria.date_ = gProps.pSelectedData.date_;
                }

                let lRequestUtil = new CSRequestUtil('GET', lServiceCode, lServiceObject.type_);
                lRequestUtil.cfSetRequestCriteria(lCriteria);
                lRequestUtil.cfProcessRequest((lResponse) => {
                    if (lResponse) {
                        if (lResponse.hasOwnProperty('collection_')) {
                            setLocationHistory(lResponse.collection_);
                        }
                        setShowBackdrop(false);
                    }
                }
                );
            }
        }
    }

    const fnGetLocationHistory = () => {
        if (gProps.hasOwnProperty('pSelectedActionItem') && gProps.pSelectedActionItem.on_click_service_code_) {
            let lServiceCode = gProps.pSelectedActionItem.on_click_service_code_;
            let lServiceObject = (CSServiceUtil.cfGetInstance()).cfGetServiceObject(lServiceCode);
            if (lServiceObject) {
                setShowBackdrop(true);
                let lCriteria = {};

                if (gProps.pSelectedCriteria.employee_id_) {
                    lCriteria.employee_id_ = gProps.pSelectedCriteria.employee_id_;
                }

                if (gProps.pSelectedCriteria.date_) {
                    lCriteria.date_ = gProps.pSelectedCriteria.date_;
                }

                let lRequestUtil = new CSRequestUtil('GET', lServiceCode, lServiceObject.type_);
                lRequestUtil.cfSetRequestCriteria(lCriteria);
                lRequestUtil.cfProcessRequest((lResponse) => {
                    if (lResponse) {
                        if (lResponse.hasOwnProperty('collection_')) {
                            setLocationHistory(lResponse.collection_);
                        }
                        setShowBackdrop(false);
                    }
                }
                );
            }
        }
    }

    const lCordData = mLocationHistory.map(item =>
    ({
        id: item.id_,
        time: item.time_,
        lat: parseFloat(item.latitude_),
        lng: parseFloat(item.longitude_)
    }));
    
    let lCountCordData = lCordData.length;
    let lEndMarker = lCountCordData - 1;
    const lFilteredCordData = lCordData.slice(1, lCordData.length - 1);

    useEffect(() => {
        if (navigator.geolocation) {
            const watchId = navigator.geolocation.watchPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const newLocation = { lat: latitude, lng: longitude };
                    setCurrentLocation(newLocation);
                },
                (error) => console.error('Error getting location:', error),
                { enableHighAccuracy: true }
            );

            return () => navigator.geolocation.clearWatch(watchId);
        } else {
            alert('Geolocation is not supported by your browser.');
        }
    }, []);

    const fnCloseForm = (lCloseFlag) => {
        setDetailsFlag(null);

        if (gProps.fnProcessClose) {
            gProps.fnProcessClose(lCloseFlag);
        }
    }

    const MapPoints = () => {
        if (mFeatureName === 'LIVE LOCATION') {
            lCordData.push(mCurrentLocation)
        }
        let lineSymbol = {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            scale: 3
        };
        return (
            <>

                {
                    lFilteredCordData.map((item) => (
                        <Marker
                            icon={{ url: (('./mark.png')) }}
                            // icon={MarkIcon}
                            key={item.id}
                            position={item}
                            title={item.time}
                        />
                    ))
                }

                <Marker
                    position={lCordData[0]}
                    icon={{ url: (('./home-filled.png')) }} />

                <Marker
                    position={mFeatureName === 'LOCATION HISTORY' ? lCordData[lEndMarker] : mCurrentLocation}
                    icon={{ url: (('./avatar.png')) }} />

                <Polyline
                    path={lCordData}
                    options={{
                        strokeColor: '#fc0303', 
                        strokeWeight: 0,
                         icons: [{
                            icon: lineSymbol,
                            offset: '0',
                            repeat: '15px'
                        }],
                    }}
                />
            </>
        )
    }

    return (
        <Dialog
            header={mFeatureName}
            maximizable={true}
            visible={mVisible} style={{ width: '80vw', height: '80vw' }} onHide={fnCloseForm}>
            <LoadScript googleMapsApiKey={Google_key}>
                <CSCOBackdrop pShow={mShowBackdrop} />
                <GoogleMap
                    mapContainerStyle={lMapContainerStyle}
                    center={lCordData[0]}
                    // center={mFeatureName === 'LOCATION HISTORY' ? lCordData[0] : mCurrentLocation}
                    zoom={12} >
                    <MapPoints />
                    {/* {mFeatureName === 'LOCATION HISTORY' ? <MapPoints /> : null} */}
                    {/* {mFeatureName === 'LIVE LOCATION' ? <Marker position={mCurrentLocation} icon={{ url: (('./avatar.png')) }} /> : null} */}

                </GoogleMap>
            </LoadScript>
        </Dialog>
    )
};

export default CSCOGoogleMap;
